// + 1 is a workaround for Firefox issues with
// wrong scrollHeight value on text nodes
export const shouldShowTooltip = (trigger: HTMLElement): boolean =>
  Boolean(
    trigger &&
      (trigger.offsetWidth < trigger.scrollWidth ||
        trigger.offsetHeight + 1 < trigger.scrollHeight),
  );
